import { TitleSC } from './style'

const TitleUI = ({ children }) => {
    return <TitleSC>{children}</TitleSC>
}

export default TitleUI
